/* ==========================================================================
   diXed · Miniaturleiste der Produktseite
   Angelegt 31.08.2026. Ronnys Ansage: kein Scrollbalken bei den Bildern.

   Verhalten: Passen nicht alle Miniaturen neben das Hauptbild, wird die
   Leiste abgeschnitten und die letzte sichtbare Kachel durch einen Knopf
   "+X" ersetzt. Erst ein Klick darauf klappt den Rest auf.

   Drei Entscheidungen, die im Code sonst wie Willkuer aussehen:
   1. Gezaehlt wird gemessen, nicht geraten. Kachelhoehe und Abstand werden
      aus dem gerenderten Zustand gelesen, damit eine spaetere Aenderung an
      der Kachelgroesse hier nichts kaputtmacht.
   2. Versteckte Kacheln bekommen hidden, nicht display:none per Klasse.
      Die Kacheln, die das Theme selbst ueber hide_variants ausblendet,
      duerfen dabei nicht wieder auftauchen, deshalb wird nur gezaehlt, was
      tatsaechlich eine Hoehe hat.
   3. Kein Zurueckklappen. Wer aufgeklappt hat, will alle sehen.
   ========================================================================== */

(function () {
  'use strict';

  var MINDESTBREITE = 990;

  function sichtbareKacheln(liste) {
    return Array.prototype.filter.call(
      liste.querySelectorAll('.thumbnail-list__item'),
      function (li) {
        return li.getBoundingClientRect().height > 0 || !li.hasAttribute('hidden');
      }
    ).filter(function (li) {
      return getComputedStyle(li).display !== 'none';
    });
  }

  function aufbauen(leiste) {
    var liste = leiste.querySelector('.thumbnail-list');
    if (!liste) return;

    var kacheln = sichtbareKacheln(liste);
    if (kacheln.length < 2) return;

    var hoeheLeiste = parseFloat(getComputedStyle(leiste).maxHeight);
    if (!hoeheLeiste || isNaN(hoeheLeiste)) return;

    var kachelHoehe = kacheln[0].getBoundingClientRect().height;
    var abstand = parseFloat(getComputedStyle(liste).rowGap) || 0;
    if (!kachelHoehe) return;

    var passen = Math.floor((hoeheLeiste + abstand) / (kachelHoehe + abstand));
    if (passen >= kacheln.length) return;   /* alles passt, nichts zu tun */

    /* Der Knopf belegt selbst einen Platz, also bleibt einer weniger fuer
       Bilder. Die Zahl auf dem Knopf zaehlt alles, was dann noch fehlt. */
    var zeigen = Math.max(1, passen - 1);
    var rest = kacheln.length - zeigen;

    kacheln.forEach(function (li, i) {
      if (i >= zeigen) li.setAttribute('hidden', '');
    });

    var knopf = document.createElement('button');
    knopf.type = 'button';
    knopf.className = 'dx-mehr-bilder';
    knopf.setAttribute('aria-expanded', 'false');
    knopf.textContent = '+' + rest;
    knopf.setAttribute('aria-label', 'Weitere ' + rest + ' Bilder anzeigen');

    knopf.addEventListener('click', function () {
      kacheln.forEach(function (li) { li.removeAttribute('hidden'); });
      leiste.classList.add('dx-leiste-offen');
      knopf.remove();
    });

    liste.appendChild(knopf);
  }

  /* ------------------------------------------------------------------------
     Die Punktreihe unter dem Hauptbild.

     Ronny am 31.08.2026: bei 25 Bildern standen dort 47 Punkte. Sichtbar
     bleiben hoechstens fuenf, der aktive in der Mitte. Die aeusseren beiden
     schrumpfen, damit man sieht, dass die Reihe weitergeht.

     Beobachtet wird der Klassenwechsel an den Punkten, nicht ein bestimmtes
     Ereignis des Sliders. Eine Sperre verhindert, dass die eigenen
     Aenderungen die naechste Runde ausloesen.
     ---------------------------------------------------------------------- */

  var FENSTER = 2;          /* je Seite, ergibt hoechstens fuenf */
  var punkteLaeuft = false;

  function punkteZeigen(reihe) {
    if (punkteLaeuft) return;
    var punkte = Array.prototype.slice.call(reihe.querySelectorAll('.dixed-punkt'));
    if (punkte.length <= (FENSTER * 2 + 1)) return;

    var aktiv = punkte.findIndex(function (p) {
      return p.classList.contains('dixed-punkt--aktiv');
    });
    if (aktiv < 0) aktiv = 0;

    /* Das Fenster bleibt vollstaendig, auch am Anfang und am Ende. */
    var von = Math.max(0, Math.min(aktiv - FENSTER, punkte.length - (FENSTER * 2 + 1)));
    var bis = von + FENSTER * 2;

    punkteLaeuft = true;
    punkte.forEach(function (p, i) {
      var drin = i >= von && i <= bis;
      if (p.hasAttribute('hidden') === drin) {
        if (drin) p.removeAttribute('hidden');
        else p.setAttribute('hidden', '');
      }
      var rand = drin && (i === von || i === bis) && i !== aktiv;
      p.classList.toggle('dx-punkt--rand', rand);
    });
    punkteLaeuft = false;
  }

  function punkteAufbauen() {
    document.querySelectorAll('.dixed-punkte').forEach(function (reihe) {
      punkteZeigen(reihe);
      if (!window.MutationObserver) return;
      new MutationObserver(function () {
        punkteZeigen(reihe);
      }).observe(reihe, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });
    });
  }

  function start() {
    punkteAufbauen();
    if (window.innerWidth < MINDESTBREITE) return;
    document
      .querySelectorAll('slider-component.thumbnail-slider')
      .forEach(aufbauen);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
